"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination_1 = require("./Pagination");
exports.default = Pagination_1.default;
//# sourceMappingURL=index.js.map